import { AxiosError } from "axios";
import { sendUnauthorizedEvent } from "../../../../events";

export const errorInterceptor = (error: AxiosError) => {
  const { data } = error.response || { data: undefined };

  if (error.response?.status === 401) {
    sendUnauthorizedEvent();
  }

  if (error.message === "Network Error") {
    return Promise.reject({ ...error, message: "Erro de conexão." });
  }

  if (data) {
    return Promise.reject(error);
  }

  return Promise.reject(error);
};
